export enum LocalStorageKeys {
    lang = "lang",
    theme = "theme",
    cart = "cart",
    cartId = "cartId",
}
